module.exports = __webpack_public_path__ + "sovdapp/img/footer-logo1.a1dbe92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer-logo1.svg
// module id = n1MM
// module chunks = 1 2 3